import { Component, OnInit, Input, Output, EventEmitter, NgIterable } from '@angular/core';

import { ParameterType } from '@enums/parameter-type.enum';
import { MappingBase } from '@classes/mapping/mapping-base';

@Component({
  selector: 'app-edit-form',
  templateUrl: './edit-form.component.html',
  styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent<T extends MappingBase> implements OnInit {
  @Input() item: T;
  @Output() valueSubmitted = new EventEmitter<T>();

  editedItem: T;
  PropertyType = ParameterType;
  showAdvanced: boolean;

  constructor() {
    this.showAdvanced = false;
  }

  ngOnInit() {
    this.editedItem = this.item ? JSON.parse(JSON.stringify(this.item)) : new MappingBase('', '');
  }

  // "ugly" solution to Type 'number[] | string[]' is not assignable to type 'NgIterable<number>'
  castArray(array: number[] | string[]) {
    return array as NgIterable<number | string>
  }

  onToggleAdvanced(): void {
    this.showAdvanced = !this.showAdvanced;
  }

  onCancel(): void {
    this.valueSubmitted.emit(null);
  }

  onSubmit(): void {
    if (this.editedItem.properties) {
      this.editedItem.properties.map(prop => {
        if (prop.type === ParameterType.number && !prop.list) {
          prop.value = parseInt(prop.value as string, 10);
        }
      });
    }
    this.valueSubmitted.emit(this.editedItem);
  }
}
